<template>
  <div>
    <Modal
      ref="modal"
      v-model="showModal"
      :width="1000"
      :footer-hide="true"
      :closable="false"
    >
      <slot name="header"></slot>
      <div>
        {{ personName }} - 个人课表明细（{{ daycareNum }}个托管课、{{
          courseNum
        }}个素质课）
      </div>
      <div class="timetable-head">
        <span class="click-btn-430" @click="handleToLastWeek">上一周</span>
        <div class="date-block">
          {{ nowWeekInfo.dateText }}
        </div>
        <span class="click-btn-430" @click="handleToNextWeek">下一周</span>
      </div>
      <div class="timetable-content">
        <div
          v-for="(item, index) in timeTable"
          :key="index"
          class="timetable-item"
        >
          <div class="item-head">{{ item.name }}</div>
          <div class="item-content">
            <span v-for="(x, y) in item.list" :key="y">{{
              x.classroomName
            }}</span>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <Button @click="handleClose">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { getWeek, transferDate, fun_date } from '@/utils/utils.js';
import { weekList } from '@/utils/dictionary.js';
export default {
  props: {
    personId: {
      type: String,
      default: ''
    },
    personName: {
      type: String,
      default: ''
    },
    yearCode: {
      type: Number,
    },
    termCode: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showModal: false,
      timeTable: [], // 学校课程表
      nowDay: '', // 当前展示的当前日期
      nowWeekInfo: {}, // 当前展示的当前周
      daycareNum: 0,
      courseNum: 0
    };
  },
  watch: {
    personId(nowVal, oldVal) {
      if (nowVal) {
        this.initWeekList();
        this.nowDay = transferDate(new Date());
        this.getNowDayInfo();
      }
    }
  },
  created() {
    this.initWeekList();
    this.nowDay = transferDate(new Date());
    this.getNowDayInfo();
  },
  methods: {
    initWeekList() {
      this.timeTable = weekList.map(item => {
        return {
          name: item.label,
          value: item.value,
          list: []
        };
      });
    },
    // 获取当前时间以及当前周(周一为一周的起始)
    getNowDayInfo() {
      this.nowWeekInfo = getWeek(this.nowDay);
      if (this.personId && this.showModal) {
        this.getPersonalTable();
      }
    },
    // 上一周
    handleToLastWeek() {
      this.nowDay = fun_date(this.nowDay, -7);
      this.initWeekList();
      this.getNowDayInfo();
    },
    // 下一周
    handleToNextWeek() {
      this.nowDay = fun_date(this.nowDay, 7);
      this.initWeekList();
      this.getNowDayInfo();
    },
    async open() {
      await this.getPersonalTable();
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    handleClose() {
      this.close();
    },
    // 获取个人课表
    async getPersonalTable() {
      const params = {
        personId: this.personId,
        yearCode: this.yearCode,
        termCode: this.termCode,
        beginDateFrom: `${this.nowWeekInfo.startDate} 00:00:00`,
        beginDateTo: `${this.nowWeekInfo.endDate} 23:59:59`
      };
      const res = await courseSchedulCenter.getPersonalTimeTableApi(params);
      if (res.status === 200) {
        this.daycareNum = res.message.daycareNum;
        this.courseNum = res.message.courseNum;
        this.initWeekList();
        res.message.timetableList.forEach(item => {
          const index = this.timeTable.findIndex(x => {
            return x.value === item.dayOfWeek;
          });
          if (index >= 0) {
            this.timeTable[index].list = item.details;
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.timetable-head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  .date-block {
    border: 1px solid #ccc;
    background: rgba(0, 0, 0, 0.03);
    padding: 8px;
    width: 200px;
    text-align: center;
    border-radius: 4px;
    margin: 0 16px;
  }
}
.timetable-content {
  margin-top: 16px;
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.03);
  .timetable-item {
    width: calc(100 / 7 * 100%);
    .item-head {
      background: rgba(0, 0, 0, 0.03);
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
    }
    .item-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 24px 0;
      span {
        display: inline-block;
        padding: 8px;
        background: rgba(255, 255, 255, 0);
        cursor: pointer;
      }
      span:hover {
        background: rgba(97, 73, 241, 0.1);
        color: #488ffa;
      }
      span + span {
        margin-top: 16px;
      }
    }
  }
  .timetable-item + .timetable-item {
    border-left: 1px solid rgba(0, 0, 0, 0.03);
  }
}
.btn-box {
  margin-top: 24px;
  text-align: center;
}
</style>
